const y = "dd/MM/yyyy";
export {
  y as DATE_FORMAT
};
//# sourceMappingURL=constants12.mjs.map
